import { useNavigate } from "react-router-dom";
import { useTheme } from "next-themes";
import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import logo from "@/assets/logo.png";

/**
 * Shared top bar for all in-app screens: real logo instead of an emoji,
 * consistent brand name, theme toggle, and a slot for per-screen actions.
 */
const AppHeader = ({ right, homeTo = "/dashboard" }) => {
  const navigate = useNavigate();
  const { resolvedTheme, setTheme } = useTheme();

  return (
    <div className="dashboard-header" style={{ flexWrap: 'wrap', gap: '0.5rem' }}>
      <button
        onClick={() => navigate(homeTo)}
        style={{ display: 'flex', alignItems: 'center', gap: '10px', background: 'none', border: 'none', cursor: 'pointer', color: 'inherit' }}
        aria-label="Go to dashboard"
        data-testid="header-home"
      >
        <img src={logo} alt="" style={{ width: '32px', height: '32px', objectFit: 'contain' }} />
        <h2 style={{ fontSize: '1.35rem', fontWeight: 600 }}>Cilantro Alert</h2>
      </button>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
        {right}
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setTheme(resolvedTheme === 'dark' ? 'light' : 'dark')}
          aria-label="Toggle dark mode"
          data-testid="theme-toggle"
        >
          {resolvedTheme === 'dark' ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
        </Button>
      </div>
    </div>
  );
};

export default AppHeader;
